export const GET_PATIENT_PHYSICIAN = 'get_patient_physician';
export const GET_PATIENT_CERTIFICATION_DOC = 'get_patient_certification_doc';
export const SET_CERTIFICATION_ID = 'set_certification_id';
export const RESET_CERTIFICATION_ID = 'reset_certification_id';
export const SET_UNCLOSED_CERTIFICATION_ID = 'set_unclosed_certification_id';
export const RESET_UNCLOSED_CERTIFICATION_ID = 'reset_unclosed_certification_id';
export const REDIRECT_TO_UNCLOSED_CERT = 'redirect_to_unclosed_cert';
export const RESET_REDIRECT_TO_UNCLOSED_CERT = 'reset_redirect_to_unclosed_cert';
